export default{
	name : 'detail_dialog',
	props:{
		show : Boolean,
		list: {
			default: () => { return [] },
			type: Array
		},
		title: {
			default: '业务详情',
			type: String
		}
	},
	data () {
		return {
			lock: false
		}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		menuClick(item) {
			if(item.url.indexOf('auth') != -1 && window.localStorage.getItem("token") != undefined) {
				window.location.href = (item.url+ '&token=' + window.localStorage.getItem("token"));
				return;
			}
			window.location.href = item.url
		}
	},
	mounted() {
		for(let index = 0; index < this.list.length; index++ ){
			let item = this.list[index]
			if(item.miniId == undefined) {
				continue;
			}
			let btn = document.getElementById('launch-btn-b-'+ index);
			btn.addEventListener('launch',  (e) => {
				if(this.lock) {
					return;
				}
				this.lock = true;
				let url = 'https://user.cs96111.com/ad/record/auth?data='+item.data;
				if(window.localStorage.getItem("token") != undefined) {
					url += ('&token=' + window.localStorage.getItem("token"))
				}
				$.post(url, (result) => {
					this.lock = false;
				});
			});
		}
	},
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/detail_dialog/js/detail.js